var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZvukColorLightPadding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 50,
    viewBox: "0 0 200 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Zvuk"
  }, /*#__PURE__*/React.createElement("g", {
    id: "zvuk-color"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_ru"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 72,
    cy: 24,
    r: 20,
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1-Copy-47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M75.5755 24.8972C73.936 24.8972 72.6024 26.3203 72.6024 28.0698C72.6024 28.0812 72.6027 28.0925 72.6032 28.1002C72.5958 28.3656 72.6307 29.2111 73.2462 30.3762C74.0529 31.9028 75.503 33.3351 77.5569 34.634C77.5968 34.6639 77.6423 34.6874 77.6916 34.7029C77.7359 34.7168 77.7813 34.7237 77.8266 34.7237C77.8744 34.7237 77.922 34.716 77.9671 34.7011C78.0206 34.682 78.0562 34.6634 78.0884 34.6407C80.1423 33.3418 81.5924 31.9095 82.3991 30.3828C83.0146 29.2178 83.0495 28.3723 83.0421 28.1067C83.0424 28.0992 83.0429 28.0878 83.0429 28.0765C83.0429 26.327 81.7091 24.9039 80.0696 24.9039C79.1885 24.9039 78.0884 25.4063 77.8259 26.5483C77.5569 25.3996 76.4568 24.8972 75.5755 24.8972Z",
    fill: "url(#paint0_linear_107_365)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    d: "M73.5938 12.0611C73.4536 11.981 73.2798 11.9795 73.1383 12.0575C72.9968 12.1355 72.9094 12.2809 72.9094 12.4386V22.309C72.9094 22.4664 72.9968 22.612 73.1383 22.69C73.2079 22.7284 73.2853 22.7477 73.3627 22.7477C73.4427 22.7477 73.5226 22.7271 73.5938 22.6864L82.2065 17.7513C82.3443 17.6722 82.4288 17.5287 82.4288 17.3737C82.4288 17.2188 82.3443 17.0752 82.2065 16.9962L73.5938 12.0611Z",
    fill: "url(#paint1_linear_107_365)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    d: "M69.5316 12.8652C69.5316 12.6585 69.417 12.4686 69.2335 12.3712C68.7375 12.1079 67.9719 12.6944 67.9719 13.4256V27.8409C65.0103 26.4213 61.5476 28.6009 61.5476 31.5478C61.5476 33.1069 62.5825 34.4166 64.9369 34.4166C67.2642 34.4166 69.5184 32.3239 69.5316 28.7376V12.8652Z",
    fill: "url(#paint2_linear_107_365)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Page-1-Copy-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    d: "M136.705 20.2991H140.145L139.43 23.8067H140.463L142.949 20.2991H146.887L142.929 25.4541V25.4926L145.296 30.2796H141.577L139.946 26.6169H138.873L138.137 30.2796H134.697L136.705 20.2991Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    d: "M124.357 31.5589C124.954 31.5589 125.67 31.4039 126.207 30.551L126.505 30.0856L124.099 20.2991H127.678L128.514 25.241C128.613 25.7835 128.613 26.7139 128.613 26.7139H128.653C128.653 26.7139 129.011 25.842 129.269 25.2991L131.556 20.2991H135.414L129.011 31.3455C127.738 33.5357 125.968 34.3496 124.536 34.3496C123.622 34.3496 122.647 34.0782 121.852 33.5742L123.343 31.2489C123.602 31.4424 124.019 31.5589 124.357 31.5589Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.764 20.2991H114.276L112.268 30.2796H117.955C120.123 30.2796 122.409 29.1946 122.409 27.1209C122.409 26.3069 122.051 25.4346 121.177 25.1051V25.086C122.37 24.5432 122.867 23.5158 122.867 22.6053C122.867 21.1325 121.634 20.2991 119.764 20.2991ZM118.214 24.2332C118.89 24.2332 119.446 23.7098 119.446 23.1088C119.446 22.6828 119.168 22.3728 118.552 22.3728H117.299L116.921 24.2332H118.214ZM117.637 28.1863C118.293 28.1863 118.969 27.6828 118.969 26.9659C118.969 26.5009 118.671 26.1905 118.055 26.1905H116.523L116.126 28.1863H117.637Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-1_2",
    d: "M102.525 26.2294C103.241 27.0628 104.335 27.5472 105.348 27.5472C106.502 27.5472 107.635 26.9268 107.635 25.7449C107.635 25.0665 107.218 24.6985 106.184 24.6985H104.135L104.672 21.9849H106.403C107.377 21.9849 108.371 21.3069 108.371 20.2795C108.371 19.5821 107.993 19.1361 106.979 19.1361C106.263 19.1361 105.329 19.3496 103.976 20.2795L102.743 17.8187C104.434 16.5199 106.303 16.1904 107.556 16.1904C110.022 16.1904 112.05 17.3338 112.05 19.6595C112.05 21.2294 111.036 22.5278 109.525 23.1283L109.505 23.1672C110.479 23.6131 111.195 24.6015 111.195 25.8804C111.195 28.7486 108.232 30.5124 105.368 30.5124C103.44 30.5124 101.59 29.7175 100.536 28.3997L102.525 26.2294Z",
    fill: "#101010"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_107_365",
    x1: 66.7091,
    y1: 29.1771,
    x2: 76.4464,
    y2: 40.8566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_107_365",
    x1: 66.8422,
    y1: 18.8501,
    x2: 80.062,
    y2: 28.0357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99F6B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_107_365",
    x1: 61.5476,
    y1: 12.3071,
    x2: 61.5476,
    y2: 34.4166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5FBFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZvukColorLightPadding);
export default __webpack_public_path__ + "static/media/zvuk-color-light-padding.464952fa557095b0bf0c68433f7ad7da.svg";
export { ForwardRef as ReactComponent };